
import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'

export default class {
    @observable data = {
        userInfo: {},
        cd: 0,
        inviteCP: {},
    }

    @action async GetInviteCP({ sender, giftId, receiver } = {}) {
        sender = sender * 1;
        giftId = giftId * 1;
        receiver = receiver * 1;
        let d = await http.post('/web/cp/inviteCP', { senderId: sender, giftId, receiverId: receiver })
        this.data.inviteCP = d.res;
        // if (d && d.code == 0 && d.res && d.res.uid > 0) {
        //   this.data.userInfo = d.res
        // }
    }

    @action async GetInviteCPResult({ receiverId, senderId, inviteResult, giftId } = {}) {
        let d = await http.post('/web/cp/inviteCPResult', { receiverId, senderId, inviteResult, giftId })
        console.log('%c [ GetInviteCPResult ]-14', 'font-size:13px; background:pink; color:#bf2c9f;', d)
        // if (d && d.code == 0 && d.res && d.res.uid > 0) {
        //   this.data.userInfo = d.res
        // }
    }

    @action async GetUserInfoWeb(uid) {
        let d = await http.post('/web/MyAccountInfo', { uid: uid })
        if (d && d.code == 0 && d.res && d.res.uid > 0) {
            this.data.userInfo = d.res
        }
    }

    @action async getCd(data) {
        let res = await http.post('/web/family/rank/countDown', data)
        if (res && res.code == 0) {
            this.data.cd = res.res
            return res.res
        }
    }

    @action async getRank(data) {
        let res = await http.post('/web/family/rank', data)
        if (res && res.code == 0) {
            this.data.userList = res.res
            return res.res
        }
    }

    @action async getLevel(id) {
        let res = await http.post('/web/family/info', { familyId: id })
        if (res && res.code == 0) {
            return res.res
        }
    }

}



// WEBPACK FOOTER //
// src/store/activity/cp-yes.js